import {registerCrudStore} from '@/libs/core/+state/register-crud-store';
import {TenantDeviceSubscriptionModel} from '@/libs/Api';
import {TenantDeviceSubscriptionsDataService} from '@/libs/tenant-device-subscriptions/tenant-device-subscriptions-data-service';
import {BusinessModule} from '@/libs/core/models/business-module';

export const tenantDeviceSubscriptionsStore = registerCrudStore<TenantDeviceSubscriptionModel, TenantDeviceSubscriptionModel>(BusinessModule.TenantDeviceSubscription, new TenantDeviceSubscriptionsDataService());
